
  var shade_finder_results = {
      "q3:a1,q4:a1,q5:a1,q6:a1" : "/products/medium-dark-self-tan-mousse",
      "q3:a1,q4:a1,q5:a1,q6:a2" : "/products/medium-dark-pro-spray-mist",
      "q3:a1,q4:a1,q5:a2,q6:a1" : "/products/caramel-self-tan-foam",
      "q3:a1,q4:a1,q5:a2,q6:a2" : "/products/caramel",
      "q3:a1,q4:a1,q5:a3,q6:a1" : "/products/workout-ready-self-tan-foam",
      "q3:a1,q4:a1,q5:a3,q6:a2" : "/products/workout-ready",
      "q3:a1,q4:a2,q5:a1,q6:a1" : "/products/medium-dark-self-tan-mousse",
      "q3:a1,q4:a2,q5:a1,q6:a2" : "/products/medium-dark-pro-spray-mist",
      "q3:a1,q4:a2,q5:a2,q6:a1" : "/products/caramel-self-tan-foam",
      "q3:a1,q4:a2,q5:a2,q6:a2" : "/products/caramel",
      "q3:a1,q4:a2,q5:a3,q6:a1" : "/products/caramel-self-tan-foam",
      "q3:a1,q4:a2,q5:a3,q6:a2" : "/products/caramel",
      "q3:a1,q4:a3,q5:a1,q6:a1" : "/products/medium-dark-self-tan-mousse",
      "q3:a1,q4:a3,q5:a1,q6:a2" : "/products/medium-dark-pro-spray-mist",
      "q3:a1,q4:a3,q5:a2,q6:a1" : "/products/wonder-tan-self-tan-foam",
      "q3:a1,q4:a3,q5:a2,q6:a2" : "/products/wonder-tan-pro-spray-mist",
      "q3:a1,q4:a3,q5:a3,q6:a1" : "/products/wonder-tan-self-tan-foam",
      "q3:a1,q4:a3,q5:a3,q6:a2" : "/products/wonder-tan-pro-spray-mist",
      "q3:a2,q4:a1,q5:a1,q6:a1" : "/products/medium-dark-self-tan-mousse",
      "q3:a2,q4:a1,q5:a1,q6:a2" : "/products/medium-dark-pro-spray-mist",
      "q3:a2,q4:a1,q5:a2,q6:a1" : "/products/double-dark-self-tan-mousse",
      "q3:a2,q4:a1,q5:a2,q6:a2" : "/products/double-dark-pro-spray-mist",
      "q3:a2,q4:a1,q5:a3,q6:a1" : "/products/dark-ash-self-tan-foam",
      "q3:a2,q4:a1,q5:a3,q6:a2" : "/products/dark-ash",
      "q3:a2,q4:a2,q5:a1,q6:a1" : "/products/medium-dark-self-tan-mousse",
      "q3:a2,q4:a2,q5:a1,q6:a2" : "/products/medium-dark-pro-spray-mist",
      "q3:a2,q4:a2,q5:a2,q6:a1" : "/products/double-dark-self-tan-mousse",
      "q3:a2,q4:a2,q5:a2,q6:a2" : "/products/perfect-bride",
      "q3:a2,q4:a2,q5:a3,q6:a1" : "/products/dark-ash-self-tan-foam",
      "q3:a2,q4:a2,q5:a3,q6:a2" : "/products/perfect-bride",
      "q3:a2,q4:a3,q5:a1,q6:a1" : "/products/medium-dark-self-tan-mousse",
      "q3:a2,q4:a3,q5:a1,q6:a2" : "/products/medium-dark-pro-spray-mist",
      "q3:a2,q4:a3,q5:a2,q6:a1" : "/products/double-dark-self-tan-mousse",
      "q3:a2,q4:a3,q5:a2,q6:a2" : "/products/perfect-bride",
      "q3:a2,q4:a3,q5:a3,q6:a1" : "/products/double-dark-self-tan-mousse",
      "q3:a2,q4:a3,q5:a3,q6:a2" : "/products/perfect-bride",
      "q3:a3,q4:a1,q5:a1,q6:a1" : "/products/medium-dark-self-tan-mousse",
      "q3:a3,q4:a1,q5:a1,q6:a2" : "/products/medium-dark-pro-spray-mist",
      "q3:a3,q4:a1,q5:a2,q6:a1" : "/products/workout-ready-self-tan-foam",
      "q3:a3,q4:a1,q5:a2,q6:a2" : "/products/workout-ready",
      "q3:a3,q4:a1,q5:a3,q6:a1" : "/products/olive-self-tan-foam",
      "q3:a3,q4:a1,q5:a3,q6:a2" : "/products/olive",
      "q3:a3,q4:a2,q5:a1,q6:a1" : "/products/medium-dark-self-tan-mousse",
      "q3:a3,q4:a2,q5:a1,q6:a2" : "/products/medium-dark-pro-spray-mist",
      "q3:a3,q4:a2,q5:a2,q6:a1" : "/products/workout-ready-self-tan-foam",
      "q3:a3,q4:a2,q5:a2,q6:a2" : "/products/workout-ready",
      "q3:a3,q4:a2,q5:a3,q6:a1" : "/products/olive-self-tan-foam",
      "q3:a3,q4:a2,q5:a3,q6:a2" : "/products/olive",
      "q3:a3,q4:a3,q5:a1,q6:a1" : "/products/moroccan-self-tan-foam",
      "q3:a3,q4:a3,q5:a1,q6:a2" : "/products/moroccan",
      "q3:a3,q4:a3,q5:a2,q6:a1" : "/products/wonder-tan-self-tan-foam",
      "q3:a3,q4:a3,q5:a2,q6:a2" : "/products/wonder-tan",
      "q3:a3,q4:a3,q5:a3,q6:a1" : "/products/wonder-tan-self-tan-foam",
      "q3:a3,q4:a3,q5:a3,q6:a2" : "/products/wonder-tan",
      "q3:a4,q4:a1,q5:a1,q6:a1" : "/products/violet-self-tan-foam",
      "q3:a4,q4:a1,q5:a1,q6:a2" : "/products/violet",
      "q3:a4,q4:a1,q5:a2,q6:a1" : "/products/violet-self-tan-foam",
      "q3:a4,q4:a1,q5:a2,q6:a2" : "/products/violet",
      "q3:a4,q4:a1,q5:a3,q6:a1" : "/products/violet-self-tan-foam",
      "q3:a4,q4:a1,q5:a3,q6:a2" : "/products/violet",
      "q3:a4,q4:a2,q5:a1,q6:a1" : "/products/coconut-water-self-tan-foam",
      "q3:a4,q4:a2,q5:a1,q6:a2" : "/products/coconut",
      "q3:a4,q4:a2,q5:a2,q6:a1" : "/products/violet-self-tan-foam",
      "q3:a4,q4:a2,q5:a2,q6:a2" : "/products/violet",
      "q3:a4,q4:a2,q5:a3,q6:a1" : "/products/violet-self-tan-foam",
      "q3:a4,q4:a2,q5:a3,q6:a2" : "/products/violet",
      "q3:a4,q4:a3,q5:a1,q6:a1" : "/products/coconut-water-self-tan-foam",
      "q3:a4,q4:a3,q5:a1,q6:a2" : "/products/coconut",
      "q3:a4,q4:a3,q5:a2,q6:a1" : "/products/coconut-water-self-tan-foam",
      "q3:a4,q4:a3,q5:a2,q6:a2" : "/products/coconut",
      "q3:a4,q4:a3,q5:a3,q6:a1" : "/products/violet-self-tan-foam",
      "q3:a4,q4:a3,q5:a3,q6:a2" : "/products/violet",
      "q3:a5,q4:a1,q5:a1,q6:a1" : "/products/double-dark-self-tan-mousse",
      "q3:a5,q4:a1,q5:a1,q6:a2" : "/products/double-dark-pro-spray-mist",
      "q3:a5,q4:a1,q5:a2,q6:a1" : "/products/dark-ash-self-tan-foam",
      "q3:a5,q4:a1,q5:a2,q6:a2" : "/products/dark-ash",
      "q3:a5,q4:a1,q5:a3,q6:a1" : "/products/dark-ash-self-tan-foam",
      "q3:a5,q4:a1,q5:a3,q6:a2" : "/products/dark-ash",
      "q3:a5,q4:a2,q5:a1,q6:a1" : "/products/double-dark-self-tan-mousse",
      "q3:a5,q4:a2,q5:a1,q6:a2" : "/products/double-dark-pro-spray-mist",
      "q3:a5,q4:a2,q5:a2,q6:a1" : "/products/dark-ash-self-tan-foam",
      "q3:a5,q4:a2,q5:a2,q6:a2" : "/products/dark-ash",
      "q3:a5,q4:a2,q5:a3,q6:a1" : "/products/dark-ash-self-tan-foam",
      "q3:a5,q4:a2,q5:a3,q6:a2" : "/products/dark-ash",
      "q3:a5,q4:a3,q5:a1,q6:a1" : "/products/double-dark-self-tan-mousse",
      "q3:a5,q4:a3,q5:a1,q6:a2" : "/products/double-dark-pro-spray-mist",
      "q3:a5,q4:a3,q5:a2,q6:a1" : "/products/double-dark-self-tan-mousse",
      "q3:a5,q4:a3,q5:a2,q6:a2" : "/products/double-dark-pro-spray-mist",
      "q3:a5,q4:a3,q5:a3,q6:a1" : "/products/dark-ash-self-tan-foam",
      "q3:a5,q4:a3,q5:a3,q6:a2" : "/products/dark-ash",
      "q3:a6,q4:a1,q5:a1,q6:a1" : "/products/ultra-dark-self-tan-mousse",
      "q3:a6,q4:a1,q5:a1,q6:a2" : "/products/ultra-dark-pro-spray-mist",
      "q3:a6,q4:a1,q5:a2,q6:a1" : "/products/absolute-self-tan-foam",
      "q3:a6,q4:a1,q5:a2,q6:a2" : "/products/absolute",
      "q3:a6,q4:a1,q5:a3,q6:a1" : "/products/absolute-self-tan-foam",
      "q3:a6,q4:a1,q5:a3,q6:a2" : "/products/absolute",
      "q3:a6,q4:a2,q5:a1,q6:a1" : "/products/ultra-dark-self-tan-mousse",
      "q3:a6,q4:a2,q5:a1,q6:a2" : "/products/ultra-dark-pro-spray-mist",
      "q3:a6,q4:a2,q5:a2,q6:a1" : "/products/absolute-self-tan-foam",
      "q3:a6,q4:a2,q5:a2,q6:a2" : "/products/absolute",
      "q3:a6,q4:a2,q5:a3,q6:a1" : "/products/absolute-self-tan-foam",
      "q3:a6,q4:a2,q5:a3,q6:a2" : "/products/absolute",
      "q3:a6,q4:a3,q5:a1,q6:a1" : "/products/ultra-dark-self-tan-mousse",
      "q3:a6,q4:a3,q5:a1,q6:a2" : "/products/ultra-dark-pro-spray-mist",
      "q3:a6,q4:a3,q5:a2,q6:a1" : "/products/ultra-dark-self-tan-mousse",
      "q3:a6,q4:a3,q5:a2,q6:a2" : "/products/ultra-dark-pro-spray-mist",
      "q3:a6,q4:a3,q5:a3,q6:a1" : "/products/ultra-dark-self-tan-mousse",
      "q3:a6,q4:a3,q5:a3,q6:a2" : "/products/ultra-dark-pro-spray-mist"
  };
  
  jQuery(document).ready(function($) {  
  	initShadeFinder();
  });
  function markAnswered() {
    $('.question').each(function() {
      if($(this).find('input:checked').length > 0) {
        $(this).addClass('answer-selected');
      } else {
        $(this).removeClass('answer-selected');        
      }
    });
  }
  function scrollToShadeFinder() {
      var $target = $('#shade-finder');
      if (!$target.length) $target = $('.shade-finder-page').first();
      if (!$target.length) $target = $('.shade-finder-form').first();
      var offset = $target.offset();
      if (!offset) return;
      var headerHeight = $('.header-bottom.fix-sticky').height() || 0;
      $('html,body').stop(true).animate({ scrollTop: Math.max(0, offset.top - headerHeight) }, 300);
  }

  function initShadeFinder() {
      if($('.shade-finder-form').length == 0) return;
      $('#show-shade-finder').click(function(e) {
          e.preventDefault();
          $('#intro').hide();
          $('#shade-finder').show();
          scrollToShadeFinder();
      });
      
      $('.shade-finder-form label').click(function() {
          $('.shade-finder-error').empty().hide();
          markAnswered();
        
          var $container = $(this).closest('.question') 
          if($container.find('.sf-next').length>0) {
            setTimeout(function() { $container.find('.sf-next').trigger('click') }, 100);
          } else if($container.find('.sf-result').length>0) {
            setTimeout(function() { $container.find('.sf-result').trigger('click') }, 100); 
          }
      });
  
      $('.shade-finder-form input').change(function() {
          $('.shade-finder-error').empty().hide();
          markAnswered();
      });

      $('.info-tooltip').hover(function() {
        $(this).find('.info-tooltip-data').fadeIn();
      }, function() {
        $(this).find('.info-tooltip-data').fadeOut();          
      });
  
      $(document).on('click', '.shade-finder-form .shade-finder-progress li.past', function(e) {
          e.preventDefault();
          var current_i = $(this).index();
          var $qs = $('.shade-finder-form .question');
          $('.shade-finder-form .shade-finder-progress li').removeClass('past').removeClass('active');
          $(this).addClass('active');
          $(this).prevAll().addClass('past');
        
          $qs.removeClass('active'); 
          $qs.eq(current_i).addClass('active');
          scrollToShadeFinder();
      });
  
      $('.shade-finder-form .btn').click(function(e) {
          e.preventDefault();
          $('.shade-finder-error').empty().hide();
          markAnswered();
          var $q = $('.shade-finder-form .question.active');
          var current_i = $q.index();
        
          if($(this).hasClass('sf-next')) {
              if($q.find('input:checked').length != 0) {
                var $current = $('.shade-finder-form .shade-finder-progress li').eq(current_i+1);
                $.when(
                  $q.removeClass('active'),
                  $('.shade-finder-form .shade-finder-progress li').removeClass('past active')                
                ).then(          
                  $q.next().addClass('active'),
                  $current.addClass('active'), 
                  $current.prevAll().addClass('past'),     
                  scrollToShadeFinder()
                );
              }
          } else if($(this).hasClass('sf-prev')) {
            var $current = $('.shade-finder-form .shade-finder-progress li').eq(current_i-1);
            $.when(
              $q.removeClass('active'),
              $('.shade-finder-form .shade-finder-progress li').removeClass('past active')
            ).then(
              $q.prev().addClass('active'),
              $current.addClass('active'),
              $current.prevAll().addClass('past'),
              scrollToShadeFinder()
            ); 
          } else if($(this).hasClass('sf-result')) {
              if($q.find('input:checked').length != 0) {
                var result_url = false;
                var result_match = '';
                $('.shade-finder-form .question:not([data-skip="1"])').each(function() {
                  result_match += $(this).data('id')+':'+$(this).find('[name^="shade_finder"]:checked').val()+',';
                });
                result_match = result_match.substr(0, result_match.length-1);
                if(typeof shade_finder_results[result_match] !== 'undefined') {
                  result_url = shade_finder_results[result_match];
                }
                if(result_url) {
                  window.location.href = result_url;
                } else {
                  $('.shade-finder-error').text($('.shade-finder-form').attr('data-result-error')).show().trigger('focus');
                }
              }                
          }
      });
  }